export interface Menu {
    name: string;
    page: string;
    id?: number;    
    icon?: string;
}

export interface Login {
    email: string;
    password: string;
}